var swfobject = {
  hasFlashPlayerVersion: function() {
    return false;
  },
  getFlashPlayerVersion: function() {
    return { major: 0, minor: 0, release: 0};
  }
}